import React, { useEffect }  from 'react';
import "./QuestionInfo.scss";


function Question(props) {
    var orgAndSponsor = ""
    if (props.surveySponsor === null) {
        orgAndSponsor = props.surveyOrganization.replace("; ", "/")
    } else {
        orgAndSponsor = props.surveySponsor.replace("; ", "/") + "/" + props.surveyOrganization.replace("; ", "/")
    }

    return (
        <div className="citation">
            {orgAndSponsor} poll of {props.surveyAudience}, {props.startDate} - {props.endDate}
        </div>
    );
}

export default Question;
